import { axiosInstance } from '../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../Shared/Utils/UrlConstants';

const Service = {
  getAuditLogsList: (data = {}) => {
    return axiosInstance.get(ApiUrlConstant.auditLogsList(data), data, { loaderKey: 'audit-logs' });
  },
};

export default Service;
